import { ExpectedCompletionB50 } from './ExpectedCompletionB50';
import { ExpectedCompletionCV50 } from './ExpectedCompletionCV50';

interface ExpectedCompletionProps {
  isB50: boolean;
}

export const ExpectedCompletion = ({ isB50 }: ExpectedCompletionProps): JSX.Element =>
  isB50 ? <ExpectedCompletionB50 /> : <ExpectedCompletionCV50 />;
